<template>
  <div>
    <v-data-table :headers="headers" :items="messages" hide-actions class="elevation-1">
      <template slot="items" slot-scope="props">
        <!-- <router-link class="cursor" tag="tr" :to="`/messages/${props.item.id}`"> -->
        <tr @click="props.expanded = !props.expanded">
          <td class="text-xs-left">
            {{ props.item.created | moment("dddd, MMMM Do YYYY, h:mm:ss")}},
            <br>
            {{props.item.created | moment("from", "now")}}
          </td>
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.email }}</td>
          <td class="text-xs-left">
            <v-btn color="error" @click.stop="deleteMessage(props.item.id)">Delete Message</v-btn>
          </td>
        </tr>
        <!-- </router-link> -->
      </template>
      <template slot="expand" slot-scope="props">
        <v-card class="grey lighten-2 px-4 py-2" flat>
          <v-card-text class="px-0 body-2">
            <v-textarea
              :value="props.item.message"
              readonly
              :label="`Message from: ${props.item.name}`"
              :rules="nameRules"
              box
              auto-grow
              required
            ></v-textarea>
            Send message to: {{props.item.name}}, (email: {{props.item.email}})
          </v-card-text>
          <v-form ref="messageback" v-model="valid">
            <v-textarea v-model="message" label="Message" :rules="nameRules" box auto-grow required></v-textarea>
            <div class="body-2 ml-2">{{res}}</div>
            <v-btn
              :disabled="!valid"
              @click="sendEmail(props.item)"
              class="light-blue darken-2"
              color="white"
              flat
            >Send Message</v-btn>
          </v-form>
        </v-card>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { db } from "../firebase";
import axios from "axios";
export default {
  data() {
    return {
      nameRules: [v => !!v || "This field is mandatory"],
      valid: false,
      res:'',
      message: "",
      messages: [],
      headers: [
        {
          text: "Date",
          sortable: true,
          value: "name"
        },
        {
          text: "Name",
          sortable: false,
          value: "name"
        },
        {
          text: "Email",
          sortable: false,
          value: "name"
        },
        {
          text: "",
          sortable: false,
          value: ""
        }
      ]
    };
  },
  methods: {
    getMessages() {
      let result = [];
      db.collection("messages")
        .get()
        .then(items => {
          items.forEach(category => {
            let categoryData = category.data();
            categoryData.id = category.id;
            result.push(categoryData);
          });
        })
        .catch(e => {
          console.error(`Error happended: ${e}`);
        });
      this.messages = result;
    },
    sendEmail(item) {
      
      const { email } = item;
      const message = this.message;
      if (this.$refs.messageback.validate()) {
        axios
          .post(process.env.VUE_APP_SEND_URL, {
            to:email,
            subject:'Caos Suits',
            email:'CEO of Caos Suits',
            type:'message',
            name:'Heath Thomas Weeks',
            message
          })
          .then(res => {
            this.res = res.data.message;
            })
          .catch(e => {
            this.res = e.data.message
            console.log("err", e)
            });
      }
    },
    deleteMessage(id) {
      db.collection("messages")
        .doc(id)
        .delete()
        .then(() => {
          this.getMessages();
        })
        .catch(error => {
          console.error("Error removing document: ", error);
        });
    }
  },
  created() {
    this.getMessages();
  }
};
</script>
